import { api } from 'app/api';

// i-12
export const savePatientInfo = async (data) => {
  return await api.post(`/dfd/api/if/web/v1/hsptlz-form-sign-patient-info-save`, data);
};
